import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BehaviorSubject, Observable, startWith } from 'rxjs';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-tri-checkbox-input',
    templateUrl: './generic-tri-checkbox-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-tri-checkbox-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericTriCheckboxInputComponent,
        },
    ],
})
export class GenericTriCheckboxInputComponent extends BaseGenericInputComponent<boolean> {

    public hover$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    public checked$: Observable<boolean | undefined>;
    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }
    public ngOnInit(): void {
        super.ngOnInit();
        this.checked$ = this.inputFormControl.valueChanges.pipe(startWith(this.inputFormControl.value));
    }

    public setTriCheckboxValue(): void {
        const currentValue: boolean = this.inputFormControl.value;
        if (currentValue === undefined) {
            this.inputFormControl.setValue(true);
        } else if (currentValue === false) {
            this.inputFormControl.setValue(undefined);
        } else if (currentValue) {
            this.inputFormControl.setValue(false);
        } else {
            this.inputFormControl.setValue(true);
        }
    }

}
